import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LeftOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import selector from '@store/changeLog/selectors';
import * as actions from '@store/changeLog/actions';
import { ChangeLogTable } from './components';
import { Wrapper, PageTitle } from './styled';
import { names } from './constants';

const ChangeLog = ({ location }) => {
  const params = new URLSearchParams(location.search);
  const type = params.get('type') || '';
  const back = params.get('back') || '';
  const pageName = names[type];
  const { logs, loading } = useSelector(selector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(actions.init(type));
  }, [dispatch]);

  return (
    <Wrapper>
      <PageTitle>
        {back ? <Link to={back}><LeftOutlined /></Link> : null}
        Change Log
        {' '}
        {pageName ? `for ${pageName}` : ''}
      </PageTitle>
      <ChangeLogTable loading={loading} logs={logs} type={type} />
    </Wrapper>
  );
};

export default ChangeLog;
